var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOob(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 990.99 994.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 112.67,
    y1: 927.2,
    x2: 236.59,
    y2: 267.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b4b3b2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#f3f2f2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 430.14,
    y1: 316,
    x2: 890.03,
    y2: 779.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#fbfbfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c3c1be"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "a"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "79.83 681.2 .12 142.27 287.37 328.39 360.11 994.46 79.83 681.2",
    style: {
      fill: "url(#b)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "287.21 328.4 990.78 132.3 980.55 721.71 359.89 994.31 287.21 328.4",
    style: {
      fill: "url(#c)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0 142.43 640.25 0 990.99 132.45 287.3 328.58 0 142.43",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "398.73 747.41 407.98 833.06 918.22 631.7 919.35 554.75 398.73 747.41",
    style: {
      fill: "#252325"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "78.89 522.71 89.29 592.9 314.62 824.34 305.37 736.9 78.89 522.71",
    style: {
      fill: "#24252a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "252.95 243.6 291.39 267.74 847.93 117.31 804.69 97.92 252.95 243.6",
    style: {
      fill: "#24252a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "e"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "278.28 714.12 302.84 737.5 311.15 812.91 286.05 787.27 278.28 714.12",
    style: {
      fill: "#096a51"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "270.16 706.39 278.28 714.12 286.05 787.27 278.28 779.34 270.16 706.39",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "265.42 701.88 270.16 706.39 278.28 779.34 273.54 774.5 265.42 701.88",
    style: {
      fill: "#f9b14c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "251.8 688.91 265.42 701.88 273.54 774.5 259.7 760.36 251.8 688.91",
    style: {
      fill: "#ef2e3b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "203.19 642.64 251.8 688.91 259.7 760.36 211.78 711.42 203.19 642.64",
    style: {
      fill: "#71adc5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "196.21 636 203.19 642.64 211.78 711.42 204.64 704.12 196.21 636",
    style: {
      fill: "#feffff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "164.78 606.08 196.21 636 204.64 704.12 173.18 671.99 164.78 606.08",
    style: {
      fill: "#fab148"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "122.44 565.77 164.78 606.08 173.18 671.99 131.31 629.23 122.44 565.77",
    style: {
      fill: "#0f6b51"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "131.31 629.23 89.54 586.57 80.39 525.75 122.44 565.77 131.31 629.23",
    style: {
      fill: "#74aec5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "498.46 713.32 401.26 749.28 409.52 823.04 504.57 785.89 498.46 713.32",
    style: {
      fill: "#74aec6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "683.48 644.87 668.46 650.43 671.72 720.55 686.53 714.76 683.48 644.87",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "795.15 603.55 683.48 644.87 686.53 714.76 796.63 671.73 795.15 603.55",
    style: {
      fill: "#75aec7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "838.43 587.54 826.93 591.8 827.41 659.69 839.2 655.09 838.43 587.54",
    style: {
      fill: "#f9b14c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "856.5 580.86 838.43 587.54 839.2 655.09 856.79 648.21 856.5 580.86",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "856.79 648.21 911.98 626.64 913.08 559.92 856.5 580.86 856.79 648.21",
    style: {
      fill: "#0c6d53"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "826.93 591.8 795.15 603.55 796.63 671.73 827.41 659.69 826.93 591.8",
    style: {
      fill: "#ef2e3b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "668.46 650.43 595.67 677.36 600.01 748.58 671.72 720.55 668.46 650.43",
    style: {
      fill: "#f9b04b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "595.67 677.36 498.46 713.32 504.57 785.89 600.01 748.58 595.67 677.36",
    style: {
      fill: "#0f6b51"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "359.73 216.4 257.07 243.55 289.96 264.44 392.9 236.72 359.73 216.4",
    style: {
      fill: "#72adc5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "462.22 189.31 359.73 216.4 392.9 236.72 496.79 208.74 462.22 189.31",
    style: {
      fill: "#0f6b51"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "539.71 168.82 462.22 189.31 496.79 208.74 574.52 187.81 539.71 168.82",
    style: {
      fill: "#fbb04b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "555.7 164.59 539.71 168.82 574.52 187.81 590.58 183.48 555.7 164.59",
    style: {
      fill: "#fefffe"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "674.19 133.26 555.7 164.59 590.58 183.48 709.85 151.36 674.19 133.26",
    style: {
      fill: "#74aec5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "707.63 124.42 674.19 133.26 709.85 151.36 744.66 141.99 707.63 124.42",
    style: {
      fill: "#ed2f39"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "720.03 121.14 707.63 124.42 744.66 141.99 756.52 138.8 720.03 121.14",
    style: {
      fill: "#faaf4f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "739.85 115.9 720.03 121.14 756.52 138.8 776.22 133.49 739.85 115.9",
    style: {
      fill: "#fffffe"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "776.22 133.49 836.04 117.38 798.89 100.29 739.85 115.9 776.22 133.49",
    style: {
      fill: "#0e6950"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m607.13,531.67c2.16,75.65-52.9,149.16-130.21,156.45-55.12,5.02-83.8-42.65-89.4-91.52-10.77-75.92,29.45-148.57,106.56-166.28,73.25-17.24,113.72,31.39,113.05,101.35Zm-149.65,28.48c-.83,29.16,12.86,63.85,47.88,48.41,25.65-10.6,33.01-41.3,30.09-66.53-.73-10.54-3.45-21.31-9.92-29.83-11.19-15.48-33.8-12.64-47.36-1.91-15.21,11.58-21.09,31.37-20.68,49.86Z",
    style: {
      fill: "#242020"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m736.97,476.71c-1.34-36.13-2.43-72.26-3.55-108.39-.18-6-.39-5.35,4.84-6.93,13.65-4.13,27.34-8.14,41.02-12.18,19.64-5.81,39.27-11.68,58.95-17.39,25.02-8,60.44-12.56,68.79,19.71,5.62,24.6-6.02,49.43-24.61,65.36-5.96,4.76,1.38,3.57,4.7,4.71,39.59,6.51,35.26,56.45,21.21,83.92-7.7,16.1-20.41,29.57-36.23,37.88-20.87,10.17-43.5,16.26-65.13,24.65-21.91,7.63-43.52,16.26-65.6,23.35-1.32-.14-.78-2.64-1.08-3.56-1.18-37.04-1.98-74.1-3.31-111.13.07,0-.07,0,0,0Zm69.9,23.78s-.04,0,0,0c.25,8.34.51,16.68.76,25.02.02,1.22-.02,3.31,1.82,2.81,7.65-2.38,15.25-5.16,22.52-8.52,16.09-7.64,22.47-27.29,18.67-43.92-4.58-18.97-27.58-8.31-40.04-4.54-4.58,1.11-3.79,2.85-3.84,6.84,0,7.43.12,14.87.12,22.31Zm-1.59-94.52c.09,0-.09,0,0,0,.12,7.13.23,14.26.36,21.39.09,1.2-.09,3.19,1.61,3.17,14.15-4.07,32.12-8.46,37.28-24.14,2.83-9.71,5.15-25.95-6.99-29.95-10.38-2.58-20.74,2.19-30.59,4.92-2.63.76-1.77,3.85-1.95,5.93,0,6.22.26,12.45.26,18.67Z",
    style: {
      fill: "#242020"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m329.46,127.04c19.44-.46,38.9,1.33,57.73,6.39,20.79,5.13,61.91,24.11,32.32,47.07-24.75,17.79-55.59,24.6-84.97,30.66-29.99,5.51-60.78,7.47-91.11,3.91-24.1-1.17-94.46-24.46-56.59-54.79,36.01-25.03,99.2-33.39,142.63-33.24Zm-31.33,62.92c15.63-.45,31.7-3.35,45.69-10.52,13.4-7.73,1.77-17.29-7.81-20.93-18.29-7.55-38.69-7.05-57.67-2.56-51.29,12.2-8.16,34.69,19.79,34.01Z",
    style: {
      fill: "#231e1f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m276.37,527.51c-.32,8.83.45,18.5-5.85,25.41-1.33,1.31-1.31,2.6-.33,4.04,13.81,24.6,20.45,52.48,22.9,80.42,1.17,12.8,2,25.87-.54,38.57-3.55,18.24-14.66,8.79-23.38.27-13.98-12.84-27.87-25.78-41.8-38.67-1.44-1.37-2.94-2.68-3.1-4.83-8.84-74.29-18.24-148.52-26.82-222.85-.19-1.66-.3-3.33-.41-4.99-.04-.58-.06-1.27.61-1.54.62-.26,1.18.1,1.68.44,4.27,2.91,8.54,5.8,12.78,8.74,17.4,13.07,38.97,22.83,48.1,43.83,10.47,22.12,15.43,46.82,16.13,71.16Zm-11.07,90.15c-1.64-20.19-3.32-42.64-21.31-54.9-.57-.29-1.67-.32-1.57.69.37,4.07.73,8.14,1.17,12.2,1.56,14.45,3.35,28.87,5.18,43.29.11.92.33,1.8.99,2.48,9.73,9.73,14.55,12.83,15.53-3.76Zm-13.67-105.26c-.62-17.05-3.46-37.02-19.44-46.55-2.26-.71,1.14,17.86,1.01,20.23.97,8.58,1.98,17.16,3.02,25.73.58,4.8.63,4.79,4.28,8,9.11,8.68,11.63,2.26,11.13-7.41Z",
    style: {
      fill: "#242022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m645.22,47.72c11.41.29,22.38.55,33.32,3.64,13.98,4.63,17.37,11.03,3.6,19.67-1.27,2.04,8.94-.19,10.4.05,20.67-1.33,43.11-2.86,62.17,6.68,23.49,13.82-11.41,26.09-23.74,28.83-41.56,10.82-83.15,21.54-124.69,32.43-4.25,1.66-6.5.25-10.27-1.74-15.8-8.12-31.58-16.29-47.4-24.36-19.66-9.9-39.38-19.7-58.9-29.88-1.06-.55-2.04-1.27-3.03-1.96-.29-.2-.26-.61.07-.78,32.9-8.26,65.99-16.2,99.04-23.95,19.42-4.48,39.54-8.39,59.45-8.62Zm-21.21,50.37c.38.74,1.12.99,1.78,1.31,8.19,3.94,16.33,7.95,24.45,12.04.95.47,1.86.93,3.02.61,6.86-1.86,13.77-3.57,20.6-5.54,3.81-1.52,18.35-5.06,12.59-10.92-7.66-5.41-17.31-6.79-26.47-5.86-11.32,1.15-22.37,3.84-33.33,6.78-1.03.26-2.07.52-2.63,1.57Zm-11.53-30.6c-11.34.3-22.76,3.25-33.82,5.7-.89.28-2.26.53-2.85,1.19.1.41.26,1,.57,1.15,7.52,3.63,15.06,7.21,22.58,10.82,1.33.64,2.63.53,3.99.2,4.84-1.64,33.55-5.64,28.93-13.21-5.18-4.67-12.46-5.74-19.42-5.85Z",
    style: {
      fill: "#241e20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m158.45,512.13c.46,74.36-38.11,40.14-60.65-1.3-16.17-29.97-26.21-62.86-32.45-96.24-3.54-19.15-17.64-102.72,19.18-91.9,20.63,8.4,32.46,29.43,42.14,48.36,20.32,43.83,30.41,93,31.78,141.09Zm-31.3-44.42c-1.34-22.56-6.89-66.41-27.04-79.5-15.29-4.39-7.12,35.59-6.2,43.47,2.71,15.77,6.92,31.74,15.81,45.25,12.72,18.22,18.37,8.07,17.43-9.21Z",
    style: {
      fill: "#221e20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m616.05,537.61c-1.09-34.73,25.81-67.49,60.43-73.25,25.9-5.15,45.13,6.48,49,33.23,5.6,34.2-13.91,70.15-46.25,83.11-37.65,15.48-63.67-2.27-63.18-43.09Zm72.77-17.85c.56-8.04-5.06-17.23-13.78-16.12-10.87,1.14-19.52,10.17-21.3,20.76-2.74,16.47,9.71,26,24.12,16.34,7.03-5.22,10.71-12.22,10.96-20.98Z",
    style: {
      fill: "#242020"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m472.27,155.79c-9.21-.33-17.55-.74-25.74-2.6-10.26-1.77-31.67-11.51-16.56-22.72,9.74-6.59,21.33-9.58,32.59-12.41,19.95-4.8,40.64-6.48,61.04-3.93,18.82,1.74,45.53,13.92,15.68,27.79-20.81,9.07-44.61,12.95-67.01,13.86Zm12.58-14.9c4.25.23,28.05-2.66,23.27-10.33-8.21-5.68-20.29-3.69-29.57-1.9-20.25,5.32-7.42,13.07,6.31,12.22Z",
    style: {
      fill: "#221f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m209.85,555.7c1.03,28.18-9.7,34.87-26.9,10.1-14.81-24.08-26.5-70.67-20.55-98.48,3.59-13.49,15.69-6.25,21.4,1.59,17.41,22.4,25.3,58.76,26.05,86.79Zm-32.59-47.1c.42,9.24,3.88,25.59,11.71,31.06,3.47,1.2,4.47-5.11,4.22-7.5-.64-5.42-1.07-10.88-2.61-16.16-1.84-8.23-12.41-27.68-13.31-7.41Z",
    style: {
      fill: "#262323"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m720.19,590.65c0,1.97,0,3.94,0,5.92-.01,4.03.21,3.91-3.95,5.4-26.89,9.89-53.91,19.4-80.86,29.14-1.51.27-3.94,2.11-4.83.14-.78-7.38-.8-14.84-1.28-22.24.16-1.75-.81-4.47,1.14-5.41,13.53-5.32,27.39-9.81,41.14-14.54,15.55-5.07,30.67-11.49,46.33-16.19.62-.13,1.2.33,1.26,1,.44,5.59,1.03,11.18,1.04,16.8Z",
    style: {
      fill: "#242020"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m476.29,409.22c-.24,16.21-12.02,33.83-29.28,31.7-17.9-3.76-20.93-26.95-12.91-40.83,12.61-23.33,41.75-18.3,42.18,9.13Z",
    style: {
      fill: "#242020"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m536.97,390.25c.07,9.5-2.8,17-8.15,23.58-2.22,2.73-4.91,4.91-7.93,6.75-4.4,2.69-9.14,3.09-14.05,2.25-2.56-.44-4.88-1.61-6.95-3.22-3.2-2.49-5.52-5.63-6.83-9.46-4.73-13.8-.06-28.63,10.46-36.98,4.62-3.67,9.78-5.28,15.68-4.71,5.66.55,10.06,3.2,13.31,7.74,3.19,4.46,4.69,9.48,4.46,14.03Z",
    style: {
      fill: "#242020"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m579.09,145.37c.21.94.06,1.15-.3,1.27-.87.27-1.71.61-2.59.84-21.69,5.68-43.37,11.35-65.06,17.02-7.03,1.84-14.09,3.58-21.11,5.5-1.9.52-3.49.4-5.19-.61-2.99-1.78-6.08-3.39-9.11-5.1-.76-.5-.62-1.4.32-1.61,8.45-2.37,16.91-4.76,25.38-7.04,19.84-4.93,39.61-10.12,59.4-15.25,1.9-.49,3.88-1.33,5.73-1.12,4.28,1.16,8.52,4.21,12.53,6.11Z",
    style: {
      fill: "#262122"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m174.73,566.68c.29.04.67-.03.86.13,1.73,1.47,3.43,2.98,5.13,4.48,8.5,7.54,17,15.09,25.51,22.63,2.32,2.47,6.12,4.08,6.44,7.83.98,7.97,2.02,15.93,3.02,23.89.15.9-.73,1.28-1.47.86-11.93-10.48-23.31-21.67-35.1-32.35-1.43-1.32-2.12-2.75-2.34-4.68-.7-6.32-1.58-12.63-2.36-18.94.02-1.26-.61-2.83.31-3.85Z",
    style: {
      fill: "#231f22"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m204.79,127.12c5.58-.95,29.45,2.21,21.32,11.46-8.48,5.54-19.33,6.71-29.31,6.31-5.89-.79-12.45-.98-17.35-4.71-4.25-3.57.15-8.05,3.99-9.43,6.74-2.94,14.06-3.94,21.35-3.63Z",
    style: {
      fill: "#242022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m258.39,131.15c-5.75.04-28.19-1.85-20.55-11.51,10.35-7.28,24.44-6.93,36.52-5.35,7.64.94,17.72,6.76,6.68,12.67-7,3.46-14.97,3.99-22.65,4.19Z",
    style: {
      fill: "#232121"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m112.93,323.45c-.09,3.32.02,5.92-.77,8.42-.27.86-.56,1.74-1,2.52-1.04,1.88-2.8,2.27-4.61,1.08-1.94-1.28-3.32-3.09-4.51-5.05-2.05-3.39-3.6-7.01-4.87-10.75-2-5.91-3.2-12.01-3.88-18.19-.28-2.55-.16-5.15-.14-7.72.01-1.85.56-3.59,1.46-5.2,1.06-1.87,2.75-2.3,4.63-1.3,1.37.73,2.51,1.75,3.35,3.01,1.25,1.89,2.53,3.8,3.48,5.85,4.13,8.9,6.43,18.26,6.83,27.34Z",
    style: {
      fill: "#272323"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m88.11,306.12c.08,3.37-.39,5.9-.87,8.43-.08.44-.29.86-.44,1.29-1.14,3.27-4.05,2.92-5.84,1.56-2.22-1.69-3.77-3.92-5.04-6.36-3.16-6.08-5.48-12.47-6.86-19.19-.86-4.16-1.53-8.33-1.36-12.61.07-1.84.4-3.61.92-5.36.3-1.03.84-1.94,1.58-2.72.82-.86,2.28-1.27,3.34-.71.92.48,1.88,1.05,2.56,1.82,1.19,1.36,2.34,2.8,3.23,4.37,5.3,9.39,8.2,19.49,8.79,29.48Z",
    style: {
      fill: "#232222"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOob);
export default __webpack_public_path__ + "static/media/oob.eb4550417cbec568fcd6be879cfdf735.svg";
export { ForwardRef as ReactComponent };